<template>
<v-app>
  <v-content>
  <v-container fluid ma-0 pa-0 v-resize="onResize">
    <v-img src="../../static/img/coffee_bg.png" :width="x" :height="y" class="bgimage">
        <nav class="navbar navbar-light" style="height: 10px;">
          <a class="navbar-brand" href="#">
            <img src="../../static/img/logo.svg" width="60" height="40" class="d-inline-block align-top" alt="">
            <div style="display: inline-block; padding-left: 5px; color: #00513B;font-weight: 700;">
              <span color="primary--text">KENYA COFFEE </span>
            </div>
          </a>
          <div id="navbarNav" style="margin-right: 200px;">
          <ul class="nav justify-content-end">
            <li class="nav-item">
              <a class="nav-link links" href="/">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://onlinebanking.co-opbank.co.ke/" target="_blank">Co-op Online</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.nairobicoffeeexchange.co.ke/" target="_blank">NCE</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.agricultureauthority.go.ke/" target="_blank">AFA</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.cma.or.ke/" target="_blank">CMA</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links active" href="/login">Login</a>
            </li>
          </ul>
        </div>
        </nav>
      <v-layout row wrap style="margin-top:80px; margin-left:120px" v-if="showone === false">
        <v-flex d-flex xs12 sm6 md5>
          <v-layout align-center justify-center column fill-height>
          <v-flex xs12>
          <v-card flat style="background-color: transparent;">
          <h3 class="primary--text homehead"> Coffee Farming in Kenya </h3>
          <v-card-text style="margin-top: 0px;">
          <p>{{ farmingtext | truncate(200, '...') }} </p>
          <a class="primary--text link" href="#" @click="more('Coffee Farming in Kenya', farmingtext)"> more </a>
          </v-card-text>
          </v-card>
          </v-flex>
          <v-flex xs12>
          <v-card flat style="background-color: transparent;">
          <h3 class="primary--text homehead"> Kenyan Coffee </h3>
          <v-card-text>
          <p style="font-weight: 600;"> {{ kenyancoffeetext | truncate(200, '...') }} </p>
          <a class="primary--text link" href="#" @click="more('Kenyan Coffee', kenyancoffeetext)"> more </a>
          </v-card-text>
          </v-card>
          </v-flex>
         </v-layout>
        </v-flex>
        <v-flex d-flex xs12 sm6 md5 offset-md1>
          <v-card flat style="background-color: transparent;">
          <h3 class="primary--text homehead"> History </h3>
          <v-card-text>
          <p> {{ historytext | truncate(200, '...') }}</p>
          <a class="primary--text link" href="#" @click="more('History', historytext)"> more </a>
          </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap style="margin-top:80px; margin-left:120px" v-if="showone">
        <v-flex d-flex xs12 sm6 md10>
          <v-layout align-center justify-center column fill-height>
            <v-card flat style="background-color: transparent;">
              <h3 class="primary--text homehead"> {{ displayheader }} </h3>
              <v-card-text>
                <p> {{ displaytext }} </p>
                <a class="primary--text link" href="#" @click="less"> less </a>
              </v-card-text>
            </v-card>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-img>
  </v-container>
</v-content>
</v-app>
</template>
<script>
export default {
  name: 'home',
  data (router) {
    return {
      section: 'home',
      x: 0,
      y: 0,
      contact: {},
      farmingtext: 'The coffee industry of Kenya is noted for its cooperative system of production, processing, milling, marketing, and auction system. About 70% of Kenyan coffee is produced by small-scale farmers. It was estimated in 2012 that there were about 150,000 coffee farmers in Kenya and that six million Kenyans were employed directly or indirectly in the coffee industry. - Wikipedia',
      kenyancoffeetext: 'Kenyan coffee is considered by connoisseurs to be one of the world’s top coffees. Due to its unique and fine taste, over the years, Kenyan coffee. has also been blended with poorer coffees from different countries in order to improve the other coffee’s quality and flavour.',
      historytext: 'It is widely believed that coffee farming was introduced in Kenya in 1893 by the French Holy Ghost Fathers who brought coffee trees from Reunion Island. The mission farms near Nairobi, the capital city of Kenya, were used as the nucleus around which Kenyan coffee growing developed. Another reference claims the British introduced coffee growing into Kenya about 1900. - Wikipedia',
      showone: false,
      displayheader: '',
      displaytext: ''
    }
  },
  mounted () {
    this.onResize()
  },
  methods: {
    more (header, text) {
      this.displayheader = header
      this.displaytext = text
      this.showone = true
    },
    less () {
      this.showone = false
    },
    onResize () {
      this.x = window.innerWidth
      this.y = window.innerHeight
    }
  }
}

</script>
<style scoped>
.loginfront {
  background: #000000B2 0% 0% no-repeat padding-box;
  padding-left: 40px;
}
.links {
  padding-left: 30px;
  padding-right: 30px;
  color: #00513B;
  font-size: 14px;
  font-weight: 600;
  font-style:"Brandon Grotesque";
}
.active {
  width: 150px;
  background-color: #7BC243;
  text-align: center;
  border-radius: 5px 5px 5px 5px;
}
.textbold {
  line-height: 80%;
  color: white;
  font-size: 16px;
  font-style: "Brandon Grotesque";
  font-weight: 500;
}
.textlight {
  line-height: 80%;
  color: white;
  font-size: 14px;
  font-style: "Brandon Grotesque";
  font-weight: 300;
}
.labeltext {
  color: white;
}
.form-control {
  background: #000000 0% 0% no-repeat padding-box;
  color: white;
  font-size: 14px;
}
.btn {
  font-weight: 700;
  border-radius: 8px;
}
.homehead{
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  margin-left: 15px;
}
.link {
  text-decoration: underline;
}

</style>
